import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import {
  AccessControl,
  AppContext,
  EventEmitter,
  getParsedCrudData,
  getTranslatedText,
  isAuthorised,
  SelectionSheet,
  T2,
  toast,
  CardContent,
  SkeletonLoading,
  WorklogSection,
  useUserMSPCheckHook,
  useUserMSPCheckHookBasedOnProduct,
  FeatureGuide,
  withErrorBoundary,
  ProductWorklogs,
  Column,
  Row,
  COMMON_CONSTANTS,
  useProduct,
  useActivityTracker,
  AddProducts,
  UnifiedRunbookList,
  DateTimeFormatter,
  ALL_MODULES,
  useIsAuthorisedHook,
  useCheckIsItProduct
} from '@nile/components';
import {
  AccountClient,
  CREATE_APPROVAL,
  CREATE_TASKS,
  GET_ALL_APPROVAL_STATUS,
  GET_ALL_APPROVERS,
  GET_APPROVALS,
  GET_ENTITY_PROPERTIES,
  GET_INTEGRATIONS_BY_IDS,
  GET_TICKET_ASSETS,
  RESEND_APPROVAL,
  RMMClient,
  TicketClient,
  UPDATE_APPROVAL,
  UPDATE_TICKET_ASSETS,
  DETACH_TICKETS
} from '@nile/graphql';
import { GET_ASSETS_FILTER } from '@nile/rmm/src/modules/asset-management/Graphql/asset';
import { ALL_ASSET_TYPES } from '@nile/rmm/src/constants';
import envConfig from '@nile/home/src/Config/env';
import { PROPERTY_ORDER } from '@nile/mangifera/src/Constants/Tickets';
import AssociateTasks from '@nile/mangifera/src/Containers/SheetContainers/AssociateTasks';
import TicketContext from '@nile/mangifera/src/Contexts/TicketContext';
import AssetActionsCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/asset-actions';
import AssetTypeCell from '@nile/rmm/src/modules/asset-management/components/sub-pages/asset-type-cell';
import {
  Sheet,
  ProgressBar,
  ButtonGroup,
  Button,
  Card,
  Avatar,
  Link,
  DisplayText,
  Heading,
  TextStyle,
  Popover,
  ActionList,
  Tippy,
  Modal,
  TextContainer
} from '@superops/ui-design-system';
import { useFlags, withLDConsumer } from 'launchdarkly-react-client-sdk';
import dayjs from 'dayjs';
import { isEmpty, pick } from 'lodash';
import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
  useMemo
} from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  INTEGRATIONS,
  INTEGRATIONS_NON_SOLO
} from '@nile/rmm/src/modules/asset-management/constants/asset-list';
import { SVGIcon } from '@superops/super-icons';
import { useCheckFeatureGating } from '@nile/components/src/HOC/withPlanFeatureGating';
import { TicketDetailsModal } from '@nile/mangifera/src/Modal/TicketDetailsModal';
import TicketAssetsSheet from '@nile/mangifera/src/Containers/SheetContainers/TicketAssetsSheet';
import { SUBPAGE } from '@nile/components/src/Pages/SystemTrayChatPage/constants';
import { GET_ACTIVE_CONVERSATION_THREAD } from '@nile/components/src/Pages/SystemTrayChatPage/graphql';
import getUpdates from '@nile/components/src/Pages/SystemTrayChatPage/utils/getUpdates';
import { useChatFeatureEnabled } from '@nile/components/src/Pages/SystemTrayChatPage/utils';
import TicketSchedulingCard from '../CardContainers/TicketSchedulingCard';
import { ModuleBasedServiceCatalogModal } from '@nile/client_management/src/Contracts/DeliveryMap/ServiceCatalog/ModuleBasedServiceCatalogModal';
import TicketStateCard from '@nile/mangifera/src/Containers/CardContainers/TicketStateCard.js';
import ApproverListSheet from '@nile/mangifera/src/Containers/SheetContainers/ApproverListSheet.tsx';
import TicketUserApproval from '@nile/mangifera/src/Containers/CardContainers/TicketUserApproval.js';
import AssociateRunbookSheetNew from '@nile/mangifera/src/Containers/ToolbarContainers/AssociateRunbookSheetNew';
import InvoicedItemsList from '@nile/components/src/Containers/InvoicedItemsList';
import { useIntl } from 'react-intl';
import TicketInsightTriageCard from '@nile/mangifera/src/Containers/CardContainers/TicketInsightTriageCard.tsx';
import SystemTrayChatWrapper from '@nile/components/src/Components/SystemTrayChatWrapper';
import { LinkedItemsList } from '@nile/components/src/Containers/LinkedItemsList';
import { GET_PROJECTS } from '@nile/projects/src/Graphql';

const Display = ({ icon, text, color, length }) => {
  return (
    <div className="flex g3">
      <div>
        <SVGIcon name={icon} color={color} />
      </div>
      <div>
        <TextStyle variation="subdued">
          {length} {text}
        </TextStyle>
      </div>
    </div>
  );
};

function Insights(props) {
  const { intl, ticket, refetchTicket, flags, getItemsToInvoice } = props;
  const { totalTasks, completedTasks } = ticket;
  const [ticketAssets, setTicketAssets] = useState([]);
  const [openAssetuserList, setOpenAssetuserList] = useState(false);
  const [allAssetLoading, setAllAssetLoading] = useState(false);
  const appContext = useContext(AppContext);
  const currentUser = appContext?.user || {};
  const isMSP = useUserMSPCheckHook();
  const isMSPBasedonProduct = useUserMSPCheckHookBasedOnProduct();
  const userRole = currentUser?.role?.roleFeatureList || [];
  const isAssetAuthorised = useIsAuthorisedHook('asset.view');
  const isOpenChat = sessionStorage.getItem('OpenChat');
  const [allActiveConversations, setAllActiveConversations] = useState(null);
  const [activeChat, setActiveChat] = useState({});
  const isChatAvailable = useChatFeatureEnabled();
  const { concurrentAsset, sendClientEvent } = getUpdates(ticket.ticketId);
  const [runbookSheetActive, setRunbookSheetActive] = useState(false);
  const toggleRunbookSheetActive = () => {
    setRunbookSheetActive(!runbookSheetActive);
  };

  const isProjectAuthorised = useIsAuthorisedHook('project.view');

  const isItProduct = useCheckIsItProduct();

  const [
    getProjects,
    { loading: projectsLoading, data: projectsData }
  ] = useLazyQuery(GET_PROJECTS, {
    fetchPolicy: 'cache-and-network'
  });

  const projectIds = useMemo(() => {
    return (
      ticket?.workItem?.associations?.map(
        (association) => association.workId
      ) || []
    );
  }, [ticket?.workItem?.associations]);

  useEffect(() => {
    if (isProjectAuthorised && projectIds.length > 0) {
      getProjects({
        variables: {
          listInfo: {
            condition: {
              joinOperator: 'AND',
              operands: [
                {
                  attribute: 'projectId',
                  operator: 'includes',
                  value: projectIds
                }
              ]
            }
          },
          isItProduct: isItProduct
        }
      });
    }
  }, [isProjectAuthorised, isItProduct]);

  const { data: entityFields, loading, error } = useQuery(
    GET_ENTITY_PROPERTIES,
    {
      client: AccountClient,
      variables: {
        input: {
          recipients: {
            receiver: []
          }
        }
      }
    }
  );

  useQuery(GET_ACTIVE_CONVERSATION_THREAD, {
    client: TicketClient,
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
    onCompleted: ({ getActiveConversationThread }) => {
      setAllActiveConversations(getActiveConversationThread);
    }
  });

  const [associateAssetsWithTicket] = useMutation(UPDATE_TICKET_ASSETS);

  const [createTasks] = useMutation(CREATE_TASKS, {
    onCompleted() {
      toast('success', 'ticket.details.tasks.create.taskAssociate.success');
      EventEmitter.dispatch('taskAddition');
    }
  });
  let planNameGrow = '';
  let planNameStandardPsa = '';
  let planNameRise = '';
  if (flags?.connectPlan) {
    planNameGrow = 'grow';
    planNameStandardPsa = 'standard-psa';
    planNameRise = 'rise';
  }
  const fetchAssetList = (assetIds) => {
    if (!assetIds || assetIds?.length === 0) return;
    setAllAssetLoading((prevState) => !prevState);
    RMMClient.query({
      query: GET_ASSETS_FILTER,
      fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
      variables: {
        viewType: ALL_ASSET_TYPES.ALL_MONITORED_ASSET,
        listInfo: {
          condition: {
            joinOperator: 'AND',
            operands: [
              {
                attribute: 'assetId',
                operator: 'includes',
                value: assetIds || []
              }
            ]
          }
        }
      }
    })
      .then((res) => {
        setTicketAssets(res?.data?.getAllAssets?.assets || []);
        const assetWithUser = res?.data?.getAllAssets?.assets?.filter(
          (ast) => !isEmpty(ast?.workstationInfo?.assetUserLoggedIn)
        );
        if (!isEmpty(assetWithUser)) {
          sendClientEvent({
            event: 'TICKET_ASSET_REGISTER',
            id: ticket?.ticketId,
            data: {
              assets: assetWithUser?.map((ast) => ({
                assetId: ast?.assetId,
                assetUserId:
                  ast?.workstationInfo?.assetUserLoggedIn?.[0]?.userId
              }))
            }
          });
        }
      })
      .finally(() => setAllAssetLoading((prevState) => !prevState));
  };
  const { loading: ticketAssetsLoading, refetch: assetRefetch } = useQuery(
    GET_TICKET_ASSETS,
    {
      variables: {
        id: ticket.ticketId
      },
      onCompleted(res) {
        if (res?.getTicket) {
          if (isAssetAuthorised) {
            fetchAssetList(
              res.getTicket.assets.map((asset) => {
                return asset.assetId;
              })
            );
          } else {
            setTicketAssets(res?.getTicket.assets || []);
          }
        }
      }
    }
  );

  const refetchAssets = () => {
    assetRefetch().then((res) => {
      if (res?.data?.getTicket) {
        if (isAssetAuthorised) {
          fetchAssetList(
            res.data.getTicket.assets.map((asset) => {
              return asset.assetId;
            })
          );
        } else {
          setTicketAssets(res?.data?.getTicket?.assets);
        }
      }
    });
  };

  const openCallBack = (param) => {
    setActiveChat(param);
  };

  const handleCloseChat = (val) => {
    setActiveChat(val);
    setAllActiveConversations(null);
    EventEmitter.dispatch('refetchTicketAudit');
  };

  const openChat = (dta) => {
    const CHAT_PARAMS = {
      id: 'agentChatWindow',
      subject: ticket?.subject,
      module: 'TICKET',
      data: {
        ...ticket,
        module: 'TICKET',
        page: 'DETAILS'
      },
      type: 'CHAT',
      component: SystemTrayChatWrapper,
      hasAdditionalProps: true,
      chatData: { ...dta, configuredIntegrations: configuredIntegrations },
      subpage: SUBPAGE.TICKET,
      openCallBack: () => openCallBack(dta),
      setActiveChat: handleCloseChat
    };
    try {
      useActivityTracker({
        event: 'INITIATE_CHAT - TICKET'
      });
    } catch (err) {
      console.log(err);
    }
    EventEmitter.dispatch('createGlobalConversation', CHAT_PARAMS);
  };

  const checkForDisable = (ast, asset) => {
    if (!isEmpty(activeChat)) {
      return true;
    }
    if (!isEmpty(concurrentAsset)) {
      const assetInSession = concurrentAsset.find(
        (el) =>
          el?.assetId === asset?.assetId && el?.assetUserId === ast?.userId
      )?.chatActiveSession;
      return assetInSession;
    }
    if (!isEmpty(allActiveConversations)) {
      const techInSession =
        allActiveConversations?.recipients?.initiator?.user?.userId ===
        currentUser?.user?.userId;
      const isSameAsset = allActiveConversations?.recipients?.receiver?.find(
        (el) => el?.referenceId === ast?.userId && el?.name === ast?.userName
      );
      if (!isEmpty(isSameAsset) && techInSession) {
        return false;
      }
      return techInSession;
    }
    return false;
  };

  const getTippyMessage = (ast, asset) => {
    if (!isEmpty(concurrentAsset)) {
      const assetInSession = concurrentAsset.find(
        (el) =>
          el?.assetId === asset?.assetId && el?.assetUserId === ast?.[0]?.userId
      )?.user;
      if (assetInSession) {
        return 'msp.chat.asset.has.chatwithuser';
      }
    }
    if (isEmpty(ast)) {
      return 'msp.chat.initiate.nouser.found';
    }
    if (
      !isEmpty(allActiveConversations) &&
      allActiveConversations?.workItem?.workId !== ticket?.ticketId
    ) {
      return 'asset.details.toolbar.technician.activeChat';
    }
    return 'asset.details.toolbar.initiateChat';
  };

  useEffect(() => {
    if (
      isOpenChat &&
      !isEmpty(ticketAssets) &&
      !allAssetLoading &&
      flags?.agentChatFe &&
      isChatAvailable
    ) {
      const loggedUsers = ticketAssets?.[0]?.workstationInfo?.assetUserLoggedIn;
      if (!isEmpty(loggedUsers)) {
        if (loggedUsers?.length > 1) {
          setOpenAssetuserList((prevState) => !prevState);
        } else {
          openChat({
            loggedinUser: loggedUsers?.[0],
            assetInfo: ticketAssets?.[0]
          });
        }
      }
      sessionStorage.removeItem('OpenChat');
    }
  }, [ticketAssets, isOpenChat, allAssetLoading, flags?.agentChatFe, openChat]);

  const [configuredIntegrations, setConfiguredIntegrations] = useState(null);

  const [fetchIntegrationsByIds] = useLazyQuery(GET_INTEGRATIONS_BY_IDS, {
    client: AccountClient,
    fetchPolicy: 'network-only',
    onCompleted: (res) => {
      if (res?.getIntegrationsByIds) {
        const activatedIntegrations = res?.getIntegrationsByIds.filter(
          (integration) => {
            return integration.activated === true;
          }
        );
        setConfiguredIntegrations(activatedIntegrations);
      }
    }
  });

  useEffect(() => {
    let integrationIds =
      currentUser?.chargeBeePlanId === 'solo'
        ? INTEGRATIONS
        : INTEGRATIONS_NON_SOLO;
    fetchIntegrationsByIds({
      variables: {
        integrationIds
      }
    });
  }, []);

  const {
    data: approvalStatuses,
    loading: statusLoading,
    error: statusError
  } = useQuery(GET_ALL_APPROVAL_STATUS);
  const [createTicketApproval] = useMutation(CREATE_APPROVAL, {
    onCompleted() {
      toast(
        'success',
        'ticket.details.insights.approvals.approvalSent.success'
      );
    },
    onError() {
      // toast('error', 'Something went wrong');
    }
  });
  const [sheetActive, setSheetActive] = useState(false);
  const toggleSheetActive = useCallback(
    () => setSheetActive((active) => !active),
    []
  );

  useEffect(() => {
    EventEmitter.subscribe('refetchTicketAssets', refetchAssets);

    return function cleanup() {
      EventEmitter.unsubscribe('refetchTicketAssets');
    };
  }, []);

  const tabContext = useContext(TicketContext);

  if (
    loading ||
    statusLoading ||
    ticketAssetsLoading ||
    allAssetLoading ||
    projectsLoading
  )
    return (
      <div className="fhp w100 p10 ghost-white" id="insights-skeleton-loader">
        <SkeletonLoading
          hideHeader
          hideSecondaryHeader
          hideStepNav
          hideTable
          showInsighteCard
          showPlainCardView={false}
          showCardView={false}
          insightCardFullWidth
        />
      </div>
    );
  if (error) return <div>Error...</div>;
  const allEntityFields =
    entityFields.getEntitiesMeta.find((el) => el.name === 'Ticket')
      ?.attributes || [];
  const propertyOrder = props.propertyOrder || PROPERTY_ORDER;
  const allFields = allEntityFields.filter((el) => !el.isCustom);
  const allSLAFields = allFields.filter(
    (el) => propertyOrder.SLA.indexOf(el.name) > -1
  );
  const keyMap = {
    firstResponseTimer: 'firstResponseDueTimeLeft',
    resolutionTimer: 'resolutionDueTimeLeft'
  };
  const calculateProgress = (completed, total) => {
    if (!total) {
      return 0;
    }
    return Math.floor((completed / total) * 100);
  };

  const handleCreateTasks = (taskList) => {
    if (!taskList?.length) return;

    createTasks({
      variables: {
        taskInput: taskList.map((task) => ({
          ...pick(task, [
            'title',
            'description',
            'technician',
            'techGroup',
            'estimatedTime',
            'inlineImages',
            'scheduledStartDate',
            'dueDate',
            'status'
          ]),
          ticket: { ticketId: ticket.ticketId }
        }))
      }
    }).then(() => {
      props.refetchTicket();
    });
  };

  const createApproval = (userList, callback) => {
    const userIdList = userList.map((el) => el.userId);
    createTicketApproval({
      variables: {
        ticketId: ticket.ticketId,
        userIdList: userIdList
      }
    }).then((res) => {
      if (callback) {
        callback();
      }
    });
  };

  const associateRunbook = (runbook) => {
    if (runbook) {
      props.updateSelection(
        'sop',
        { sopId: runbook?.sopId, name: runbook.name },
        () => {
          // refetchTicket();
          toggleRunbookSheetActive();
        }
      );
    }
  };

  const removeAssociateAssets = (asset) => {
    associateAssetsWithTicket({
      variables: {
        id: ticket.ticketId,
        deleteAssets: [
          pick(asset, [
            'assetClass.classId',
            'assetClass.name',
            'assetId',
            'client'
          ])
        ]
      },
      input: {
        id: ticket.ticketId,
        deleteAssets: [
          pick(asset, [
            'assetClass.classId',
            'assetClass.name',
            'assetId',
            'client'
          ])
        ]
      }
    }).then((res) => {
      if (res?.data?.updateTicket) {
        toast('success', 'Asset removed successfully');
      }
      refetchAssets();
    });
  };

  const dispatcherTechnicians = [];
  const defaultAttendees = [];

  if (!isEmpty(ticket?.technician)) {
    dispatcherTechnicians.push(ticket?.technician);
    defaultAttendees.push(ticket?.technician);
  }

  if (!isEmpty(ticket?.followers)) {
    ticket?.followers.forEach((el) => {
      dispatcherTechnicians.push(el);
      defaultAttendees.push(el);
    });
  }

  if (!isEmpty(ticket?.requester)) {
    defaultAttendees.push(ticket?.requester);
  }

  const isSchedulingAvailableInPlan = useCheckFeatureGating(
    'calendar_scheduling'
  );
  const isPsaOnlyPlan =
    useCheckFeatureGating('TICKETING')?.enabled &&
    !useCheckFeatureGating('WINDOWS_MANAGEMENT')?.enabled;

  const isNewContracts = useCheckFeatureGating('CONTRACT_V3')?.enabled;

  return (
    <div className="full-height overflow-auto flex col flex-no-wrap p10 g20 ghost-white pb-100">
      {props?.mode === 'insights' && (
        <TicketInsightTriageCard
          ticket={{
            ticketId: ticket?.ticketId,
            technician: ticket?.technician,
            aiAgentActionData: ticket?.aiAgentActionData
          }}
        />
      )}
      {flags?.unifiedRunbooks && props?.mode === 'insights' && (
        <>
          <TicketUserApproval ticketId={ticket?.ticketId} />
        </>
      )}
      {isMSP && (
        <AccessControl
          roleToCheck={{
            roles: ['tickets.edit', 'serviceCatalog.view']
          }}
          render={
            (ticket?.dormantType === 'DELETED' &&
              ticket?.operationalStatus === 'DORMANT') ||
            ticket?.dormantType === 'SPAM' ? (
              <TicketStateCard
                ticket={ticket}
                cardType={ticket?.dormantType}
                refetchTicket={refetchTicket}
              />
            ) : (
              <WorklogSection
                ticket={ticket}
                module="TICKET"
                workItem={{ ...ticket, workId: ticket?.ticketId }}
                refetch={refetchTicket}
                allowEmptyNotes
                mode={props?.mode === 'insights' && 'viewOnly'}
                onViewModeClick={props?.redirectToWorklogs}
                hideTaskWorkItem
                getItemsToInvoice={getItemsToInvoice}
              />
            )
          }
        />
      )}
      {props?.mode === 'insights' && (
        <LinkedItemsList
          module={ALL_MODULES.project}
          roles={['project.view']}
          disabledItem={projectsData?.getProjects?.projects?.length === 0}
          workItems={ticket?.workItem?.associations}
          headerLabelId="label.linked.project"
          emptyLabelId="project.details.noConvertedProject"
        />
      )}

      {isMSP && flags?.unifiedRunbooks && props?.mode === 'insights' && (
        <AccessControl
          roleToCheck={{
            roles: ['tickets.edit']
          }}
          render={
            <div className="w100">
              <Card customClassName="w100">
                {ticket && (
                  <UnifiedRunbookList
                    refreshTicketDetailsPage={refetchTicket}
                    ticket={ticket}
                    renderEmptyState={
                      <div className="flex fx-sb p20">
                        <div>
                          <TextStyle weight="SemiBold">
                            <FormattedMessage id="ticket.details.insights.runbook" />
                          </TextStyle>

                          <div className="mt5">
                            <TextStyle variation="subdued">
                              {getTranslatedText(
                                intl,
                                'ticket.details.actions.norunbook'
                              )}
                            </TextStyle>
                          </div>
                        </div>

                        <div>
                          <AccessControl
                            roleToCheck={{
                              roles: ['tickets.edit']
                            }}
                            render={
                              <Button
                                onClick={toggleRunbookSheetActive}
                                plain
                                icon={<SVGIcon name="Add" />}
                              />
                            }
                          />
                        </div>
                      </div>
                    }
                  />
                )}
                {runbookSheetActive && (
                  <AssociateRunbookSheetNew
                    state={runbookSheetActive}
                    toggleSheetActive={toggleRunbookSheetActive}
                    ticket={ticket}
                    associateRunbook={associateRunbook}
                  />
                )}
              </Card>
            </div>
          }
        />
      )}

      {isMSP && (
        <AccessControl
          roleToCheck={{
            roles: ['tickets.edit', 'serviceCatalog.view']
          }}
          render={
            <div className="w100">
              <Card customClassName="w100">
                <ProductWorklogs
                  ticket={ticket}
                  module="TICKET"
                  newLayout
                  mode={props?.mode === 'insights' && 'viewOnly'}
                  onViewModeClick={props?.redirectToWorklogs}
                  renderServiceCatalogModal={
                    isNewContracts ? (
                      <ModuleBasedServiceCatalogModal ticket={ticket}>
                        <Button plain icon={<SVGIcon name="Add" />} />
                      </ModuleBasedServiceCatalogModal>
                    ) : (
                      <AddProducts
                        id={ticket?.ticketId}
                        ticket={ticket}
                        client={ticket?.client}
                        module="TICKET"
                        locked
                        newLayout
                      />
                    )
                  }
                  getItemsToInvoice={getItemsToInvoice}
                />
              </Card>
            </div>
          }
        />
      )}
      {isMSP && props?.mode === 'insights' && (
        <AccessControl
          roleToCheck={{
            roles: ['invoice.view']
          }}
          render={
            <Card customClassName="w100">
              <InvoicedItemsList items={ticket.invoices} />
            </Card>
          }
        />
      )}

      {isMSP && props?.mode === 'insights' && (
        <MergedChildTicketInfoCard
          parentTicket={ticket?.parentTicket}
          ticketId={ticket?.ticketId}
          refetchTicket={refetchTicket}
        />
      )}

      {isMSP && props?.mode === 'insights' && (
        <MergedTicketsList
          childTickets={ticket?.childTickets}
          operationalStatus={ticket?.operationalStatus}
          refetchTicket={refetchTicket}
        />
      )}

      {isMSP &&
        isSchedulingAvailableInPlan?.enabled &&
        props?.mode === 'insights' && (
          // Add access control
          <>
            <div className="full-width">
              <Card customClassName="full-width" padding="sizeSmall">
                <TicketSchedulingCard
                  workItem={{ ...ticket, workId: ticket?.ticketId }}
                  dispatcherTechnicians={
                    !isEmpty(dispatcherTechnicians)
                      ? dispatcherTechnicians
                      : null
                  }
                  attendeesFromWorkItem={defaultAttendees}
                />
              </Card>
            </div>
          </>
        )}

      {props?.mode === 'insights' && (
        <>
          {ticket.sop ? (
            <>
              <div className="full-width g15">
                <Card customClassName="full-width g15" padding="sizeSmall">
                  <CardContent
                    header={
                      <FormattedMessage id="ticket.details.insights.approvals" />
                    }
                    content={
                      <ApprovalSheet
                        isMSP={isMSP}
                        sop={ticket?.sop || {}}
                        ticket={ticket}
                        createApproval={createApproval}
                        approvalStatuses={approvalStatuses.getAllApprovalStatus}
                        intl={intl}
                      />
                    }
                  />
                </Card>
              </div>
            </>
          ) : (
            <>
              <div className="full-width g15">
                <Card customClassName="full-width g15" padding="sizeSmall">
                  <CardContent
                    header={
                      <FormattedMessage id="ticket.details.insights.tasks" />
                    }
                    content={
                      <div className="progressBar flex center">
                        <ProgressBar
                          progress={calculateProgress(
                            completedTasks,
                            totalTasks
                          )}
                          size="small"
                        />
                        <div className="ml8">{`${completedTasks}/${totalTasks}`}</div>
                      </div>
                    }
                  />
                </Card>
              </div>
              <div className="full-width g15">
                <Card customClassName="full-width g15" padding="sizeSmall">
                  <CardContent
                    header={
                      <FormattedMessage id="ticket.details.insights.approvals" />
                    }
                    content={
                      <ApprovalSheet
                        isMSP={isMSP}
                        sop={ticket?.sop || {}}
                        ticket={ticket}
                        createApproval={createApproval}
                        approvalStatuses={approvalStatuses.getAllApprovalStatus}
                        intl={intl}
                      />
                    }
                  />
                </Card>
              </div>
            </>
          )}
        </>
      )}

      {isPsaOnlyPlan ? (
        <></>
      ) : (
        <>
          {props?.mode === 'insights' && (
            <>
              <div id="assetsHolder" className="full-width g15">
                <Card padding="sizeSmall">
                  <div className="flex fx-sb actr w100 mb10">
                    <div>
                      <TextStyle weight="SemiBold">
                        <FormattedMessage id="ticket.details.insights.assets" />
                      </TextStyle>
                    </div>
                    <div>
                      <AccessControl
                        roleToCheck={{
                          operator: 'AND',
                          roles: ['tickets.edit', 'asset.view']
                        }}
                        render={
                          <div className="mlauto">
                            <Button
                              onClick={toggleSheetActive}
                              size="tiny"
                              plain
                              monochrome
                              icon={<SVGIcon name="Add" />}
                            />
                          </div>
                        }
                      />
                      {sheetActive && (
                        <TicketAssetsSheet
                          toggleSheetActive={toggleSheetActive}
                          refetchAssets={refetchAssets}
                          ticket={ticket}
                          open={sheetActive}
                        />
                      )}
                    </div>
                  </div>
                  <>
                    {ticketAssets.length && configuredIntegrations ? (
                      ticketAssets.map((el) => {
                        const assetUsers =
                          el?.workstationInfo?.assetUserLoggedIn;
                        const assetHasChat = concurrentAsset.find(
                          (usr) =>
                            usr?.assetId === el?.assetId &&
                            usr?.assetUserId === assetUsers?.[0]?.userId
                        );
                        const Tag = isAssetAuthorised ? Link : TextStyle;
                        return (
                          <div className="flex asset actr mb10 hiddenContainer">
                            <AssetTypeCell cell={{ row: { original: el } }} />

                            <div className="flex f11 fcol ellipsis">
                              <div
                                className="ml8"
                                onClick={() => {
                                  if (isAssetAuthorised) {
                                    tabContext.openTab({
                                      module: 'ASSET_DETAILS',
                                      data: {
                                        id: el.assetId,
                                        classId: el?.assetClass?.classId,
                                        subject: el?.name
                                      }
                                    });
                                  }
                                }}
                              >
                                <Tag>
                                  <TextStyle weight="Medium">
                                    <div className="ellipsis">
                                    {el.name}
                                    </div>
                                  </TextStyle>
                                </Tag>
                              </div>
                              {!isEmpty(assetUsers) && isMSP ? (
                                <>
                                  {assetHasChat?.chatActiveSession ? (
                                    <div className="flex actr ml8 g3">
                                      <SVGIcon
                                        name="LiveDot"
                                        size="sm"
                                        color="#3ABF38"
                                      />
                                      <TextStyle variation="positive">
                                        <FormattedMessage id="chat.label.live" />
                                      </TextStyle>
                                    </div>
                                  ) : (
                                    <div className="ellipsis ml8">
                                      <DisplayText weight="Medium">
                                        {`${assetUsers[0]?.userName} ${
                                          assetUsers?.length > 1
                                            ? `${assetUsers?.length -
                                                1} ${getTranslatedText(
                                                intl,
                                                'role.permissionCategory.others'
                                              )}`
                                            : ''
                                        } ${
                                          assetUsers?.length > 1
                                            ? ''
                                            : getTranslatedText(
                                                intl,
                                                'operator.is'
                                              )
                                        } ${getTranslatedText(
                                          intl,
                                          'common.label.online'
                                        )}  `}
                                      </DisplayText>
                                    </div>
                                  )}
                                </>
                              ) : (
                                <></>
                              )}
                            </div>

                            <div className="mlauto flex-row flex-align-center">
                              <AccessControl
                                roleToCheck="tickets.edit"
                                render={
                                  <div className="ml8">
                                    <Button
                                      onClick={removeAssociateAssets.bind(
                                        this,
                                        el
                                      )}
                                      icon={
                                        <SVGIcon
                                          name="RejectedCircle"
                                          color="var(--sops-black-white-bg)"
                                        />
                                      }
                                    />
                                  </div>
                                }
                              />
                              {isAssetAuthorised && (
                              <div className="ml8">
                                <AssetActionsCell
                                  ticketInsights
                                  cell={{
                                    row: {
                                      original: {
                                        ...el,
                                        ...el.workstationInfo
                                      }
                                    },
                                    column: {
                                      configuredIntegrations
                                    }
                                  }}
                                />
                              </div>
                              )}
                              {flags?.agentChatFe &&
                                isAssetAuthorised &&
                                isChatAvailable &&
                                isMSPBasedonProduct && (
                                  <AccessControl
                                    roleToCheck={{
                                      operator: 'AND',
                                      roles: ['tickets.edit']
                                    }}
                                    render={
                                      <div className="ml8">
                                        <Tippy
                                          title={getTranslatedText(
                                            intl,
                                            getTippyMessage(assetUsers, el),
                                            {
                                              user:
                                                allActiveConversations
                                                  ?.recipients?.initiator?.user
                                                  ?.name,
                                              ticketId:
                                                allActiveConversations?.workItem
                                                  ?.displayId || '',
                                              userName: concurrentAsset.find(
                                                (usr) =>
                                                  usr?.assetId ===
                                                    el?.assetId &&
                                                  usr?.assetUserId ===
                                                    assetUsers?.[0]?.userId
                                              )?.user?.name,
                                              br: '/\r\n'
                                            }
                                          )}
                                        >
                                          {assetUsers?.length > 1 ? (
                                            <Popover
                                              activator={
                                                <Button
                                                  onClick={() =>
                                                    setOpenAssetuserList(
                                                      (prevState) => !prevState
                                                    )
                                                  }
                                                  icon={
                                                    <SVGIcon
                                                      name={
                                                        isEmpty(assetUsers)
                                                          ? 'ChatBubble'
                                                          : 'ChatBubbleOnline'
                                                      }
                                                    />
                                                  }
                                                  disabled={isEmpty(assetUsers)}
                                                />
                                              }
                                              active={openAssetuserList}
                                            >
                                              <ActionList
                                                actionRole="menuitem"
                                                items={assetUsers?.map(
                                                  (usr) => ({
                                                    content: (
                                                      <div className="flex g10">
                                                        <Avatar
                                                          name={usr?.userName}
                                                          size="extraSmall"
                                                        />
                                                        {usr?.userName}
                                                      </div>
                                                    ),
                                                    onAction: () => {
                                                      openChat({
                                                        loggedinUser: usr,
                                                        assetInfo: el
                                                      });
                                                      setOpenAssetuserList(
                                                        (prevState) =>
                                                          !prevState
                                                      );
                                                    }
                                                  })
                                                )}
                                              />
                                            </Popover>
                                          ) : (
                                            <Button
                                              onClick={() =>
                                                openChat({
                                                  loggedinUser: assetUsers?.[0],
                                                  assetInfo: el
                                                })
                                              }
                                              icon={
                                                <SVGIcon
                                                  name={
                                                    isEmpty(assetUsers) ||
                                                    checkForDisable(
                                                      assetUsers?.[0],
                                                      el
                                                    )
                                                      ? 'ChatBubble'
                                                      : 'ChatBubbleOnline'
                                                  }
                                                />
                                              }
                                              disabled={
                                                isEmpty(assetUsers) ||
                                                checkForDisable(
                                                  assetUsers?.[0],
                                                  el
                                                )
                                              }
                                            />
                                          )}
                                        </Tippy>
                                      </div>
                                    }
                                  />
                                )}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <>
                        {flags?.agentChatFe && isChatAvailable ? (
                          <div className="flex-center fcol tcenter">
                            <SVGIcon name="NoAsset" size="xxl" />
                            <FormattedMessage
                              id="ticket.details.insights.assets.noAssets.associateTo.chat"
                              values={{ br: <br /> }}
                            />
                          </div>
                        ) : (
                          <div>
                            <FormattedMessage id="ticket.details.insights.assets.noAssets" />
                          </div>
                        )}
                      </>
                    )}
                  </>

                  {isAssetAuthorised && (
                    <div className="mt10">
                      <div className="mb10">
                        <TextStyle weight="SemiBold">
                          <FormattedMessage id="ticket.details.insights.requesterassets" />
                        </TextStyle>
                      </div>
                      <div>
                        <AssociateAssets
                          assets={ticketAssets}
                          refetchAssets={refetchAssets}
                          ticket={ticket}
                        />
                      </div>
                    </div>
                  )}
                </Card>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

function AssociateAssets(props) {
  const { ticket, assets, refetchAssets } = props;
  const tabContext = useContext(TicketContext);
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);
  const [associateAssetsWithTicket] = useMutation(UPDATE_TICKET_ASSETS);
  const { loading, data, error } = useQuery(GET_ASSETS_FILTER, {
    client: RMMClient,
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
    variables: {
      viewType: ALL_ASSET_TYPES.ALL_MONITORED_ASSET,
      listInfo: {
        condition: {
          joinOperator: 'AND',
          operands: [
            {
              attribute: isMSPProduct ? 'client.accountId' : 'site.id',
              operator: 'is',
              value: isMSPProduct ? ticket?.client?.accountId : ticket?.site?.id
            },
            {
              attribute: 'owner.userId',
              operator: 'is',
              value: ticket.requester?.userId
            }
          ]
        }
      }
    }
  });
  if (loading) return <div>loading...</div>;
  if (error) return <div>error...</div>;
  const associatedAssets = data.getAllAssets?.assets?.filter(
    (el) => !assets.some((ast) => ast.assetId === el.assetId)
  );
  const associateAssets = (asset) => {
    const currentAssociatedAssets = props.assets || [];
    const newAssociatedAssets = [asset];
    const parsedObject = getParsedCrudData(
      currentAssociatedAssets,
      newAssociatedAssets,
      'assetId'
    );
    associateAssetsWithTicket({
      variables: {
        id: ticket.ticketId,
        addAssets: parsedObject.addedItems.map((el) => {
          return {
            assetId: el.assetId
          };
        })
      },
      input: {
        id: ticket.ticketId,
        addAssets: parsedObject.addedItems.map((el) => {
          return {
            assetId: el.assetId
          };
        })
      }
    }).then((res) => {
      if (res?.data?.updateTicket) {
        toast('success', 'Asset associated successfully');
      }
      props.refetchAssets();
    });
  };
  return (
    <div id="associate-asset-list-wrapper">
      {associatedAssets?.length > 0 ? (
        associatedAssets.map((el) => {
          return (
            <div className="flex asset actr hiddenContainer lh-40">
              <AssetTypeCell cell={{ row: { original: el } }} />
              <div
                className="ellipsis ml8"
                onClick={() => {
                  tabContext.openTab({
                    module: 'ASSET_DETAILS',
                    data: {
                      id: el.assetId,
                      classId: el?.assetClass?.classId,
                      subject: el?.name
                    }
                  });
                }}
              >
                <TextStyle weight="Medium">{el.name}</TextStyle>
              </div>

              <AccessControl
                roleToCheck="tickets.edit"
                render={
                  <div className="mlauto">
                    <Tippy interactive title="Associate">
                      <Button
                        id="psaAssociateAssets"
                        size="small"
                        onClick={associateAssets.bind(this, el)}
                        icon={
                          <SVGIcon name="RightArrowCircle" color="#4B8413" />
                        }
                      />
                    </Tippy>
                  </div>
                }
              />
            </div>
          );
        })
      ) : (
        <div className="mt10">
          <FormattedMessage id="ticket.details.insights.assets.noAssets" />
        </div>
      )}
    </div>
  );
}

function ApprovalSheet(props) {
  const { intl, sop, ticket, createTasks, approvalStatuses, isMSP } = props;
  const flags = useFlags();
  const runbookRevampFlag = flags?.unifiedRunbooks;
  const [selectedItems, setSelectedItems] = useState([]);
  const [sheetActive, setSheetActive] = useState(false);
  const appContext = useContext(AppContext);
  const currentUser = appContext?.user || {};
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);
  const userRole = currentUser?.role?.roleFeatureList || [];
  const isUserAuthorised = isAuthorised(userRole, {
    operator: 'OR',
    roles: ['users.view', 'employees.view']
  });
  useEffect(() => {
    EventEmitter.subscribe('approvalChange', updateApproversList);
    return function cleanup() {
      console.log('unmounting');
      EventEmitter.unsubscribe('approvalChange');
    };
  }, []);
  const toggleSheetActive = useCallback(
    () => setSheetActive((active) => !active),
    []
  );
  const [approvalDetailsSheetActive, setApprovalDetailsSheetActive] = useState(
    false
  );
  const toggleApprovalDetailsSheetActive = useCallback(
    () => setApprovalDetailsSheetActive((active) => !active),
    []
  );
  const {
    data: approvals,
    loading: approvalsLoading,
    error: approvalError,
    refetch
  } = useQuery(GET_APPROVALS, {
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
    variables: {
      listInfo: {
        condition: {
          joinOperator: 'AND',
          operands: [
            {
              attribute: 'ticket.ticketId',
              operator: 'is',
              value: ticket.ticketId
            }
          ]
        }
      }
    },
    onCompleted({ getApprovals }) {
      const currentApprovals = getApprovals.approvals.map((el) => {
        return {
          ...el,
          userId: el.userId,
          id: el.userId,
          name: el.name,
          label: el.name
        };
      });
      setSelectedItems(currentApprovals);
    }
  });

  const getVariables = () => {
    const input = {
      listInfo: {
        sort: [
          {
            attribute: 'name',
            order: 'ASC'
          }
        ]
      }
    };
    if (isMSPProduct) {
      input.client = {
        accountId: ticket?.client?.accountId
      };
    }
    return input;
  };
  const {
    data: allApproversList,
    loading: allApproverListLoading,
    error: allApproverListError
  } = useQuery(GET_ALL_APPROVERS, {
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
    variables: {
      input: getVariables()
    },
    client: AccountClient,
    skip: !isUserAuthorised
  });

  const updateApproversList = () => {
    refetch().then((res) => {
      if (res?.data) {
        const currentApprovals = res?.data?.getApprovals.approvals.map((el) => {
          return {
            ...el,
            userId: el.userId,
            id: el.userId,
            name: el.name,
            label: el.name
          };
        });
        setSelectedItems(currentApprovals);
      }
    });
  };

  const onSendApproval = (response) => {
    toggleSheetActive();
    updateApproversList();
    EventEmitter.dispatch('refetchTicketApproval');
  };

  if (approvalsLoading) return <div>loading...</div>;
  if (allApproverListLoading) return <></>;
  const approvalList = selectedItems; // approvals.getApprovals.approvals;
  const sentStatus = approvalStatuses.find((el) => el.state === 'CREATE').name;
  const approvedStatus = approvalStatuses.find((el) => el.state === 'APPROVE')
    .name;
  const rejectedStatus = approvalStatuses.find((el) => el.state === 'REJECT')
    .name;
  const cancelledStatus = approvalStatuses.find((el) => el.state === 'CANCEL')
    .name;
  const needMoreInfoStatus = approvalStatuses.find(
    (el) => el.state === 'NEED_MORE_INFORMATION'
  ).name;
  const sentCount = approvalList.filter((el) => el.status === sentStatus)
    .length;
  const approvedCount = approvalList.filter(
    (el) => el.status === approvedStatus
  ).length;
  const rejectedCount = approvalList.filter(
    (el) => el.status === rejectedStatus
  ).length;
  const cancelledCount = approvalList.filter(
    (el) => el.status === cancelledStatus
  ).length;
  const needMoreInfoCount = approvalList.filter(
    (el) => el.status === needMoreInfoStatus
  ).length;

  const allApprovers = allApproversList?.getTicketApproverList?.userList || [];

  const updateParent = (selectedElements) => {
    const newUsers = selectedElements.filter(
      (el) => !approvalList.some((u) => u.userId === el.userId)
    );
    if (newUsers.length) {
      props.createApproval(newUsers, updateApproversList);
    }
  };
  return selectedItems.length > 0 ? (
    <>
      <div onClick={toggleApprovalDetailsSheetActive}>
        {runbookRevampFlag ? (
          <>
            <div className="linkText">{`${approvalList?.length ||
              0} approvals sent`}</div>

            {(approvedCount > 0 ||
              rejectedCount > 0 ||
              cancelledCount > 0 ||
              needMoreInfoCount > 0) && (
              <div className="flex g10 mt10 wrap">
                {approvedCount > 0 && (
                  <Display
                    icon="Check"
                    text={
                      <FormattedMessage id="ticket.details.runbook.approved" />
                    }
                    length={approvedCount || 0}
                    color={'#00A437'}
                  />
                )}

                {rejectedCount > 0 && (
                  <Display
                    icon="RejectedCircle"
                    text={
                      <FormattedMessage id="ticket.details.runbook.rejected" />
                    }
                    length={rejectedCount || 0}
                    color={'#D72C0D'}
                  />
                )}

                {needMoreInfoCount > 0 && (
                  <Display
                    icon="Conversation"
                    text={
                      <FormattedMessage id="ticket.details.approvalBubble.needMoreInfo" />
                    }
                    length={needMoreInfoCount || 0}
                    color={'#FF7F23'}
                  />
                )}

                {cancelledCount > 0 && (
                  <Display
                    icon="Restrict"
                    text={
                      <FormattedMessage id="ticket.details.runbook.cancelled" />
                    }
                    length={cancelledCount || 0}
                    color={'##999999'}
                  />
                )}
              </div>
            )}
          </>
        ) : (
          <>
            {sentCount > 0 && (
              <div className="linkText">{`${sentCount} approvals sent`}</div>
            )}
            {approvedCount > 0 && (
              <div className="linkText">{`${approvedCount} approved`}</div>
            )}
            {rejectedCount > 0 && (
              <div className="linkText">{`${rejectedCount} rejected`}</div>
            )}
            {cancelledCount > 0 && (
              <div className="linkText">{`${cancelledCount} cancelled`}</div>
            )}
            {needMoreInfoCount > 0 && (
              <div className="linkText">{`${needMoreInfoCount} need more information`}</div>
            )}
          </>
        )}
      </div>
      <Sheet
        open={approvalDetailsSheetActive}
        onClose={toggleApprovalDetailsSheetActive}
      >
        <ApprovalDetails
          approvalList={approvalList}
          toggleApprovalDetailsSheetActive={toggleApprovalDetailsSheetActive}
          allStatuses={{
            sentStatus,
            rejectedStatus,
            approvedStatus,
            cancelledStatus,
            needMoreInfoStatus
          }}
          updateApproversList={updateApproversList}
          // resendApproval={resendApproval}
          // updateApproval={updateApproval}
        />
      </Sheet>
    </>
  ) : (
    <>
      {isMSP && (
        <>
          <div className="linkText" onClick={toggleSheetActive}>
            <div className="flex center">
              <FormattedMessage id="ticket.details.insights.initiateApprovals" />
            </div>
          </div>
          <Sheet open={sheetActive} onClose={toggleSheetActive}>
            {
              <ApproverListSheet
                ticketId={ticket?.ticketId}
                client={ticket?.client}
                onSave={onSendApproval}
                onCancel={toggleSheetActive}
              />
            }
          </Sheet>
        </>
      )}
      {!isMSP && <div className="mt10"> No approvals</div>}
    </>
  );
}

function ApprovalDetails(props) {
  const {
    approvalList,
    allStatuses,
    toggleApprovalDetailsSheetActive,
    updateApproversList
  } = props;
  const appContext = useContext(AppContext);
  const flags = useFlags();
  const runbookRevampFlag = flags?.unifiedRunbooks;
  const [loading, setLoading] = useState(false);
  const { company, accountType } = appContext;
  const [updateItemId, setUpdateItemId] = useState(null);

  const {
    data: approvalStatuses,
    loading: statusLoading,
    error: statusError
  } = useQuery(GET_ALL_APPROVAL_STATUS);
  const [updateApproval, { loading: updateLoading }] = useMutation(
    UPDATE_APPROVAL,
    {
      onCompleted({ updateApproval }) {
        // toast('success', 'Approval status updated successfully');
        setLoading(false);
        updateApproversList();
      },
      onError() {
        setLoading(false);
      }
    }
  );
  const [resendApproval, { loading: resendLoading }] = useMutation(
    RESEND_APPROVAL
  );
  const resendApprovalFn = (id) => {
    resendApproval({
      variables: {
        approvalId: id
      }
    }).then((res) => {
      toast('success', 'Approval sent successfully');
      updateApproversList();
      setUpdateItemId(null);
    });
  };
  const updateApprovalFn = (id, status) => {
    const allApprovalStatuses = approvalStatuses.getAllApprovalStatus;
    const updatedStatus = allApprovalStatuses.find((el) => el.state === status);
    updateApproval({
      variables: {
        approvalId: id,
        approvalInput: {
          status: updatedStatus.name
        }
      }
    }).then((res) => {
      toast('success', 'Approval cancelled successfully');
    });
  };
  const textMap = {};
  const svgMap = {};
  textMap[allStatuses.sentStatus] = 'Waiting for approval from';
  textMap[allStatuses.approvedStatus] = 'Approved by';
  textMap[allStatuses.rejectedStatus] = 'Rejected by';
  textMap[allStatuses.cancelledStatus] = 'Cancelled by';
  textMap[allStatuses.needMoreInfoStatus] = 'Need more information';

  svgMap[allStatuses.needMoreInfoStatus] = 'Conversation';
  svgMap[allStatuses.approvedStatus] = 'Check';
  svgMap[allStatuses.rejectedStatus] = 'RejectedCircle';

  const renderActionButtons = (approvalItem, showIcon) => {
    return (
      <div className="flex jend mt10">
        {allStatuses.approvedStatus !== approvalItem.status &&
          accountType === 'MSP' && (
            <ButtonGroup>
              <Button
                loading={
                  approvalItem.approvalId === updateItemId && updateLoading
                }
                disabled={
                  approvalItem.approvalId === updateItemId && resendLoading
                }
                onClick={() => {
                  setUpdateItemId(approvalItem.approvalId);
                  updateApprovalFn(approvalItem.approvalId, 'CANCEL');
                }}
              >
                Cancel
              </Button>

              <Button
                loading={
                  approvalItem.approvalId === updateItemId && resendLoading
                }
                disabled={
                  approvalItem.approvalId === updateItemId && updateLoading
                }
                onClick={() => {
                  setUpdateItemId(approvalItem.approvalId);
                  resendApprovalFn(approvalItem.approvalId);
                }}
                icon={showIcon && <SVGIcon name="SendWhite" />}
              >
                Resend
              </Button>
            </ButtonGroup>
          )}
      </div>
    );
  };

  return (
    <div className="vw40 p15 full-height bg-white scroll">
      <div className="flex center mb20">
        <Heading element="h2" weight="SemiBold">
          <FormattedMessage id="ticket.runbook.approvals.header" />
        </Heading>
        <div
          className="mlauto pointer"
          onClick={toggleApprovalDetailsSheetActive}
        >
          <SVGIcon name="Close" />
        </div>
      </div>
      {runbookRevampFlag ? (
        <div className="p10">
          <Card padding="sizeSmall">
            <div
              className="flex col approvals-list-cards"
              id=" approvals-list-cards"
            >
              {approvalList.map((el) => {
                return (
                  <div id="approval-wrapper">
                    <div className="flex center mb20">
                      {svgMap?.[el.status] && (
                        <SVGIcon name={svgMap?.[el.status]} />
                      )}
                      <div className={svgMap?.[el.status] ? 'ml8' : ''}>
                        <TextStyle weight="SemiBold">
                          {textMap[el.status]}
                        </TextStyle>
                      </div>
                      <div className="ml-16">
                        <Avatar
                          size="small"
                          initials={`${el.approver.firstName[0]}${el.approver
                            .lastName?.[0] || ''}`}
                        />
                      </div>
                      <div className="ml8">{el.approver.name}</div>
                      <div className="mlauto">
                        <DateTimeFormatter
                          type="dateTime"
                          date={el.actionTakenOn || el.sentOn}
                        />
                      </div>
                    </div>
                    {(el?.comment || el?.additionalMessage) && (
                      <>
                        <Card
                          noShadow
                          variant={el?.comment ? 'attention' : 'secondaryCard'}
                        >
                          <div className="p10">
                            <TextStyle>
                              {el?.comment || el?.additionalMessage}
                            </TextStyle>
                          </div>
                        </Card>
                      </>
                    )}
                    {renderActionButtons(el, true)}
                  </div>
                );
              })}
            </div>
          </Card>
        </div>
      ) : (
        <>
          {approvalList.map((el) => {
            return (
              <Card padding="sizeSmall" border="secondary">
                <div className="flex center mb20">
                  <TextStyle weight="SemiBold">{textMap[el.status]}</TextStyle>
                  <div className="ml-16">
                    <Avatar
                      size="small"
                      initials={`${el.approver.firstName[0]}${el.approver
                        .lastName?.[0] || ''}`}
                    />
                  </div>
                  <div className="ml8">{el.approver.name}</div>
                  <div className="mlauto">
                    {dayjs(el.actionTakenOn || el.sentOn).format(
                      `${company?.dateFormat ||
                        'MMM DD'}, ${company?.timeFormat || 'hh:mm A'}`
                    )}
                  </div>
                </div>
                {(el?.comment || el?.additionalMessage) && (
                  <>
                    <Card
                      noShadow
                      variant={el?.comment ? 'attention' : 'secondaryCard'}
                    >
                      <div className="p10">
                        <TextStyle>
                          {el?.comment || el?.additionalMessage}
                        </TextStyle>
                      </div>
                    </Card>
                  </>
                )}
                {renderActionButtons(el)}
              </Card>
            );
          })}
        </>
      )}
    </div>
  );
}
const useDetachTickets = (onComplete) => {
  const intl = useIntl();

  const [detachTickets, { loading: detachLoading }] = useMutation(
    DETACH_TICKETS,
    {
      client: TicketClient,
      onCompleted: () => {
        toast(
          'success',
          getTranslatedText(intl, 'ticket.details.unmerge.success')
        );
        if (onComplete) onComplete();
      },
      onError: (error) => {
        toast('error', getTranslatedText(intl, 'attribute.failure'));
        if (onComplete) onComplete();
        console.error('Detach tickets error:', error);
      }
    }
  );

  const handleDetachTickets = (ticketIds) => {
    const ticketIdentifiers = ticketIds.map((ticketId) => ({
      ticketId: ticketId
    }));

    detachTickets({
      variables: {
        input: {
          tickets: ticketIdentifiers
        }
      }
    });
  };

  return { detachLoading, handleDetachTickets };
};

const MergedTicketsList = withErrorBoundary(function MergedTicketsList({
  operationalStatus,
  childTickets,
  refetchTicket
}) {
  const ticketContext = useContext(TicketContext);
  const [activeTicket, setActiveTicket] = useState(null);
  const [activeWarningModal, setActiveWarningModal] = useState(false);
  const [ticketToDetach, setTicketToDetach] = useState(null);
  const { detachLoading, handleDetachTickets } = useDetachTickets(() => {
    setActiveWarningModal(false);
    refetchTicket();
  });
  const flags = useFlags();
  const intl = useIntl();

  function onTicketClick(ticket) {
    if (!ticket) return;

    setActiveTicket(ticket);

    // ticketContext.openTicket({
    //   module: 'TICKET',
    //   ticketId: ticket.ticketId,
    //   data: {
    //     subject: ticket.subject,
    //     displayId: ticket.displayId,
    //     ticketId: ticket.ticketId
    //   }
    // });
  }

  if (!childTickets?.length) return null;

  function handleChange(ticketId = null) {
    setTicketToDetach(ticketId);
    setActiveWarningModal(!activeWarningModal);
  }

  function handleDetachTicketsAction() {
    if (ticketToDetach) {
      handleDetachTickets([ticketToDetach]);
    } else {
      const ticketIds = childTickets.map((ticket) => ticket.ticketId);
      handleDetachTickets(ticketIds);
    }
  }

  const enableUnmerge = operationalStatus !== 'DORMANT' && flags?.unmergeTicket;

  return (
    <div className="full-width">
      <Card padding="sizeSmall">
        <Row gap={5}>
          <Column className="fg1" gap={15}>
            <Row className="flex center jspbtwn" gap={5}>
              <Column>
                <TextStyle weight="Bold">
                  <FormattedMessage id="ticket.details.insight.mergedTickets" />
                </TextStyle>
              </Column>
              {enableUnmerge && (
                <AccessControl
                  roleToCheck="mergeTicket.allow"
                  render={
                    <Column onClick={() => handleChange()} className="ptr mr-5">
                      <SVGIcon name="Split" size="md" />
                    </Column>
                  }
                />
              )}
            </Row>
            <Column gap={10} className="max-height-300 scroll">
              <div>
                {childTickets.map((ticket) => {
                  return (
                    <Row
                      className="flex center jspbtwn visibilityContainer highlightOnHover p5 br-5"
                      gap={5}
                    >
                      <Column>
                        <Link
                          removeUnderline
                          onClick={() => onTicketClick(ticket)}
                        >
                          <DisplayText element="p" size="medium">
                            <FormattedMessage
                              id="ticket.details.insights.mergedTickets.ticketId"
                              values={{ id: ticket?.displayId }}
                            />
                          </DisplayText>
                        </Link>
                      </Column>
                      {enableUnmerge && (
                        <AccessControl
                          roleToCheck="mergeTicket.allow"
                          render={
                            <Column
                              onClick={() => handleChange(ticket.ticketId)}
                              className="visibilityActions ptr"
                            >
                              <SVGIcon name="Split" size="md" />
                            </Column>
                          }
                        />
                      )}
                    </Row>
                  );
                })}
              </div>
            </Column>
          </Column>
          {activeTicket && (
            <TicketDetailsModal
              ticket={activeTicket}
              onClose={() => {
                setActiveTicket(null);
              }}
            />
          )}
          <Modal
            open={activeWarningModal}
            onClose={() => handleChange()}
            medium
            iconSize="xl"
            variant="confirmation"
            title="Warning"
            showCloseButton={false}
            primaryAction={{
              content: (
                <div className="fx actr g10">
                  <SVGIcon name="CircleTickThinOutline" />
                  <FormattedMessage id="app.common.continue" />
                </div>
              ),
              loading: detachLoading,
              onAction: handleDetachTicketsAction
            }}
            secondaryActions={[
              {
                content: getTranslatedText(
                  intl,
                  'admin.mspDetails.modal.cancel'
                ),
                onAction: () => handleChange(),
                disabled: detachLoading
              }
            ]}
          >
            <div className="mt10">
              <DisplayText element="p" size="large" weight="SemiBold">
                <FormattedMessage id="ticket.details.unmerge.confirmation" />
              </DisplayText>
            </div>

            {/* <div className="mt-25">
              <TextContainer>
                <FormattedMessage id="ticket.details.unmerge.description" />
              </TextContainer>
            </div> */}
          </Modal>
        </Row>
      </Card>
    </div>
  );
});

const MergedChildTicketInfoCard = withErrorBoundary(
  function MergedChildTicketInfoCard({
    parentTicket,
    ticketId,
    refetchTicket
  }) {
    const flags = useFlags();
    const ticketContext = useContext(TicketContext);

    const { detachLoading, handleDetachTickets } = useDetachTickets(() => {
      refetchTicket();
    });

    if (!parentTicket) return null;

    function onTicketClick(ticket) {
      if (!ticket) return;

      ticketContext.openTicket({
        module: 'TICKET',
        ticketId: ticket.ticketId,
        data: {
          subject: ticket.subject,
          displayId: ticket.displayId,
          ticketId: ticket.ticketId
        }
      });
    }

    function handleDetachTicket() {
      handleDetachTickets([ticketId]);
    }

    const enableUnmerge =
      parentTicket?.operationalStatus !== 'DORMANT' && flags?.unmergeTicket;

    return (
      <Column
        className="violet-gradient rounded-2xl pt50 pb50 full-width items-center jctr"
        gap={10}
      >
        <img
          src={`${envConfig.imageRoot}svg/mergedChildTicket.svg`}
          alt=""
          width={120}
          height={102}
        />

        <DisplayText element="p" size="large" weight="Medium">
          <div className="tcenter text-black">
            <FormattedMessage
              id="ticket.details.merge.childTicket"
              values={{ br: <br /> }}
            />
          </div>
        </DisplayText>

        <div className="w-fit">
          <Link removeUnderline onClick={() => onTicketClick(parentTicket)}>
            <DisplayText element="p" size="medium">
              <FormattedMessage
                id="ticket.details.insights.mergedTickets.ticketId"
                values={{ id: parentTicket?.displayId }}
              />
            </DisplayText>
          </Link>
        </div>
        {enableUnmerge && (
          <AccessControl
            roleToCheck="mergeTicket.allow"
            render={
              <Button
                icon={<SVGIcon name="Split" />}
                loading={detachLoading}
                onClick={handleDetachTicket}
              >
                <FormattedMessage id="ticket.details.unmerge.button" />
              </Button>
            }
          />
        )}
      </Column>
    );
  }
);

export default withErrorBoundary(injectIntl(withLDConsumer()(Insights)));
